<template>
    <form @submit.prevent="handleSubmit" class="form-modal-container" data-cy="edit-container">
        <p class="text-center text-default-red p-2" v-if="validation.message">
            {{ validation.message }}
        </p>
        <div class="form-section">
            <div class="section-body">
                <div data-cy="field-expiry-date" class="input-container w-full">
                    <ui-date-picker
                        v-model="v$.user_expiry_date.expiry_date.$model"
                        :class="{ 'form-error': v$.user_expiry_date.expiry_date.$error }"
                        :disableDateFunction="disableDate"
                    />
                    <div
                        data-cy="field-expiry-date-required-error"
                        :class="{ 'text-default-red': v$.user_expiry_date.expiry_date.$error }"
                        v-if="
                            v$.user_expiry_date.expiry_date.required.$invalid && v$.user_expiry_date.expiry_date.$error
                        "
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.expiry_date" v-if="validation.errors" />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import UiDatePicker from '@/components/ui/DatePicker.vue';
import UiLabel from '@/components/ui/Label.vue';
import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiDatePicker,
        UiLabel,
        ValidationErrors,
    },
    validations: {
        user_expiry_date: {
            expiry_date: {
                required,
            },
        },
    },
    props: {
        user_expiry_date: Object,
        validation: Object,
        processing: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit');
        },
        disableDate(current) {
            return current.isBefore(new this.$dayjs());
        },
    },
};
</script>
